import React, { Fragment, useEffect, useRef, useState } from "react";
import "./KYC-Dashboard.css";

const KYC_STICKY_HEADER_OFFSET = 55;

const KycStickyTopBar = ({ className = "", variant = "dashboard", children }) => {
	const sentinelRef = useRef(null);
	const [isStuck, setIsStuck] = useState(false);
	const isMapBar = className.includes("kyc-dashboard-top-bar--map");

	useEffect(() => {
		const sentinel = sentinelRef.current;
		if (!sentinel || typeof IntersectionObserver === "undefined") {
			return undefined;
		}

		const observer = new IntersectionObserver(
			([entry]) => {
				setIsStuck(!entry.isIntersecting);
			},
			{
				threshold: 0,
				rootMargin: `-${KYC_STICKY_HEADER_OFFSET}px 0px 0px 0px`,
			}
		);
		observer.observe(sentinel);
		return () => observer.disconnect();
	}, []);

	return (
		<Fragment>
			<div
				ref={sentinelRef}
				className="kyc-dashboard-top-bar-sentinel"
				aria-hidden
			/>
			<div
				className={`kyc-dashboard-top-bar-sticky${isStuck ? " is-stuck" : ""}${
					isMapBar ? " is-map" : ""
				}${variant === "details" ? " is-details" : ""}`}>
				<div className={className}>{children}</div>
			</div>
		</Fragment>
	);
};

export default KycStickyTopBar;
